import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { UserInterface } from '@techniek-team/common';
import { OidcOauthInputConfig } from './config/oidc-oauth.config';
import { IntervalService } from './service/interval/interval.service';

/**
 * Provides silent renew functionality with a locking mechanism to prevent multiple instances
 * from refreshing the token simultaneously.
 *
 * Important: The option 'silentRenew' should be set to 'false' in the config. Otherwise the
 * default refresh mechanism will also be active.
 */
export function withSilentRenewLocking<T extends UserInterface>(): {
  options: OidcOauthInputConfig<T>;
  providers: (Provider | EnvironmentProviders)[];
} {
  return {
    options: {
      silentRenew: false,
    },
    providers: [
      IntervalService,
      provideEnvironmentInitializer(() => {
        const intervalService = inject(IntervalService);
        intervalService.startPeriodicTokenCheck();
      }),
    ],
  };
}
